import { render, staticRenderFns } from "./GuardTask.vue?vue&type=template&id=0f506bf5&"
import script from "./GuardTask.vue?vue&type=script&lang=ts&"
export * from "./GuardTask.vue?vue&type=script&lang=ts&"
import style0 from "./GuardTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports